export const getFileExtension = (filename: string): string => {
  if (!filename) return '';
  const parts = filename.split('.');
  if (parts.length >= 2) return parts.pop()!;
  return '';
};
